/**
 * Main page implementation.
 */

'use strict';


var Page   = require('stb-component-page'),
    Button = require('stb-component-button'),
    keys   = require('stb-keys'),
    page   = new Page({$node: window.pageAccountDisabled}),
    button = new Button({
        $node: window.padButton,
        value: gettext('Restart portal'),
        // focusable: true,
        events: {
            click: function () {
                window.top.location.reload();
            }
        }
        // events: {
        //     focus: function () {
        //         this.$node.className = 'ministra-button--focus'
        //     },
        //     blur: function () {
        //         this.$node.className = 'ministra-button'
        //     }
        // }
    });


window.padMainLabel.innerHTML = gettext('Service is not available.') + '<br>' + gettext('Please contact your service provider.');
button.$text.innerText = gettext('Restart portal');

button.$node.className = 'ministra-button--focus';


page.addListener('show', function () {
    setTimeout(function () {
        button.focus();
    }, 0);
});

page.addListener('keydown', function ( event ) {
    if ( event.code === keys.back ) {
        window.native.showStart();
    }
});

// public
module.exports = page;
